export * from "./ionic-rating.module";
export * from "./components/rating";
